/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Nav_Section_ClientsInputs */

const cs_nav_section_clients = /** @type {(inputs: Nav_Section_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Klienti`)
};

const en_nav_section_clients = /** @type {(inputs: Nav_Section_ClientsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Clients`)
};

/**
* | output |
* | --- |
* | "Clients" |
*
* @param {Nav_Section_ClientsInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const nav_section_clients = /** @type {((inputs?: Nav_Section_ClientsInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Nav_Section_ClientsInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_nav_section_clients(inputs)
	return cs_nav_section_clients(inputs)
});